import React, { useState, useMemo, useEffect, useContext, useRef } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  FlatList,
  StyleSheet,
  PixelRatio,
  Dimensions,
  Platform,
  ActivityIndicator,
  Modal,
  ScrollView,
  TextInput,
  Pressable,
} from "react-native";
import { Image } from "expo-image";
import { MaterialCommunityIcons, Ionicons } from "@expo/vector-icons";
import * as Google from "expo-auth-session/providers/google";
import Colours from "../../utils/Colours"; // Adjust path based on your utilities file setup
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import AppleSignin from "react-apple-signin-auth";
import {
  useNavigation,
  useRoute,
  useIsFocused,
  useNavigationContainerRef,
} from "@react-navigation/native";
import axios, { axiosWithCredentials } from "../../api/axios";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import AppContext from "../../context/AppContext";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import * as AuthSession from "expo-auth-session";
import { SafeAreaView } from "react-native-safe-area-context";

const { width, height } = Dimensions.get("window");

// --- RESPONSIVE TOOLKIT ---
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  return Math.round(PixelRatio.roundToNearestPixel(size * scaleFactor));
};
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const RevisitMenu = () => {
  const { setAuth, setActivitySettings, setUserInfo, isLoggedIn, auth } = useContext(AppContext);
  const { sub, email, phoneNumber } = useAuth();
  const isFocused = useIsFocused();
  const [allMenuItems, setAllMenuItems] = useState([]);
  const [activeShowData, setActiveShowData] = useState(null);
  const [isOngoingShow, setIsOngoingShow] = useState(false);

  const navigation = useNavigation();
  const route = useRoute();
  const axiosPrivate = useAxiosPrivate();

  // 1. Read individual primitive identifiers directly from the URL route safely
  const tableId = route.params?.tableId;
  const isTopUp = route.params?.isTopUp;
  // const { isTopUp } = route.params || {};
  const currentTier = route.params?.flexTier || "regular";
  const tableAnonymity = route.params?.tableAnonymity || false;

  console.log("anonymitye table", tableAnonymity);

  const [selectedPaymentChoice, setSelectedPaymentChoice] = useState(null); // 'NOW' or 'LATER'

  const [publicCategories, setPublicCategories] = useState(["All"]);

  const [tableDataUpdate, setTableDataUpdate] = useState();
  const [menuItems, setMenuItems] = useState([]);
  const [isCartExpanded, setIsCartExpanded] = useState(false);
  const [isProcessOrderLoading, setIsProcessOrderLoading] = useState(false);
  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [brandMeta, setBrandMeta] = useState(null); // Local state container for company styling
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [cart, setCart] = useState({}); // Shape: { [item._id]: quantity }
  //   const [isLoadingMenue, setIsLoadingMenue] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isAuthLoading, setIsAuthLoading] = useState(false);

  // Auth verification state controls
  const [isAuthModalVisible, setIsAuthModalVisible] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [isLoadingOTP, setIsLoadingOTP] = useState(false);

  const [showChoosePayment, setShowChoosePayment] = useState(false);

  const [showOverwriteModal, setShowOverwriteModal] = useState(false);

  // const userHasValidCredentials = !!(user?.email || user?.phoneNumber);
  // const userHasValidCredentials = !!email;
  const userHasValidCredentials = !!(email || phoneNumber);

  const shouldAutoOrder = useRef(false);
  const navigationRef = useNavigationContainerRef();

  // Then on focus, check the ref

  // useEffect(() => {
  //   if (!tableId) return;
  //   // //console.log("userCREDENTIALS", phoneNumber, email);

  //   const fetchScreenRequirements = async () => {
  //     if (!tableId) return;

  //     try {
  //       setIsLoading(true);

  //       // Step 1: Fetch the table context details (with populated associatedBrand)
  //       const tableResponse = await axios.get(`/tableDetailsPublic/tableDetailsPublic/${tableId}`);
  //       const tableData = tableResponse.data.tableData;

  //       setTableDataUpdate(tableData);

  //       //console.log("tableDatttta", tableResponse.data);

  //       // Update your brand layout state using the populated data
  //       setBrandMeta(tableData?.associatedBrand);

  //       // Extract the specific brand ID from the populated object
  //       const brandId = tableData?.associatedBrand?._id || tableData?.associatedBrand;

  //       if (brandId) {
  //         // Step 2: Fetch menu items based on the Brand ID and the active category selector
  //         const menuResponse = await axios.get("/getMenuItemsPublic/getMenuItemsPublic", {
  //           params: {
  //             associatedBrand: brandId,
  //             // category: selectedCategory, // "All", "Drinks", etc.
  //           },
  //         });

  //         //console.log("menuResponseDatta", menuResponse.data);

  //         // Step 3: Set items to state. The rendering layer switches between item.regularPrice
  //         // and item.doingsPrice instantly on the frontend based on your URL's 'currentTier' parameter!
  //         let serverItems = Array.isArray(menuResponse.data)
  //           ? menuResponse.data
  //           : menuResponse.data?.data || [];
  //         // setMenuItems(serverItems.filter((item) => item.isAvailable !== false));
  //         serverItems = serverItems.filter((item) => item.isAvailable !== false);

  //         // if (selectedCategory === "All" && Array.isArray(tableData?.orders)) {
  //         if (Array.isArray(tableData?.orders || [])) {
  //           const preferenceMap = {};

  //           // Traverse through all order batches on this active table
  //           tableData.orders.forEach((batch) => {
  //             if (Array.isArray(batch.items)) {
  //               batch.items.forEach((orderedItem) => {
  //                 // Safely extract the target ID string from the Schema definition
  //                 const itemIdStr = orderedItem.menuItemId?._id || orderedItem.menuItemId;
  //                 if (itemIdStr) {
  //                   // Accumulate total quantity ordered across batches
  //                   preferenceMap[itemIdStr.toString()] =
  //                     (preferenceMap[itemIdStr.toString()] || 0) + (orderedItem.quantity || 1);
  //                 }
  //               });
  //             }
  //           });

  //           // Sort descending: higher historical quantities float to the top
  //           serverItems.sort((a, b) => {
  //             const idA = (a._id || a.id)?.toString();
  //             const idB = (b._id || b.id)?.toString();
  //             const countA = preferenceMap[idA] || 0;
  //             const countB = preferenceMap[idB] || 0;
  //             return countB - countA;
  //           });
  //         }

  //         // Hydrate React state elements safely
  //         setAllMenuItems(serverItems);
  //         setMenuItems(serverItems);

  //         if (serverItems.length > 0) {
  //           const extractedCategories = [
  //             "All",
  //             ...new Set(serverItems.map((item) => item.category).filter(Boolean)),
  //           ];
  //           setPublicCategories(extractedCategories);
  //         }
  //       }
  //     } catch (error) {
  //       console.error("PWA reload hydration breakdown:", error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchScreenRequirements();
  //   // }, [tableId, selectedCategory]);
  // }, [tableId]);

  // useEffect(() => {
  //   if (selectedCategory === "All") {
  //     setMenuItems(allMenuItems);
  //   } else {
  //     // Perform an instant local client filter without hitting the server
  //     const filtered = allMenuItems.filter((item) => item.category === selectedCategory);
  //     setMenuItems(filtered);
  //   }
  // }, [selectedCategory, allMenuItems]);

  console.log("ActiveshowData", activeShowData);

  useEffect(() => {
    if (!tableId) return;

    const fetchScreenRequirements = async () => {
      try {
        setIsLoading(true);

        // Step 1: Fetch the table context details
        const tableResponse = await axios.get(`/tableDetailsPublic/tableDetailsPublic/${tableId}`);
        const tableData = tableResponse.data.tableData;

        setTableDataUpdate(tableData);
        setBrandMeta(tableData?.associatedBrand);

        const brandId = tableData?.associatedBrand?._id || tableData?.associatedBrand;

        if (brandId) {
          // Step 2: Request menu items for the host venue brand
          // Backend auto-checks if an active promoter show is currently live!
          const menuResponse = await axios.get("/getMenuItemsPublic/getMenuItemsPublic", {
            params: {
              associatedBrand: brandId,
            },
          });

          // Save active show metadata to state if present
          if (menuResponse.data?.hasActiveShow) {
            setActiveShowData(menuResponse.data.showData);
            setIsOngoingShow(true);
          } else {
            setActiveShowData(null);
          }

          // Step 3: Extract items correctly from response
          let serverItems = menuResponse.data?.data || [];
          serverItems = serverItems.filter((item) => item.isAvailable !== false);

          // Calculate item ordering based on table history
          if (Array.isArray(tableData?.orders || [])) {
            const preferenceMap = {};

            tableData.orders.forEach((batch) => {
              if (Array.isArray(batch.items)) {
                batch.items.forEach((orderedItem) => {
                  const itemIdStr = orderedItem.menuItemId?._id || orderedItem.menuItemId;
                  if (itemIdStr) {
                    preferenceMap[itemIdStr.toString()] =
                      (preferenceMap[itemIdStr.toString()] || 0) + (orderedItem.quantity || 1);
                  }
                });
              }
            });

            serverItems.sort((a, b) => {
              const idA = (a._id || a.id)?.toString();
              const idB = (b._id || b.id)?.toString();
              const countA = preferenceMap[idA] || 0;
              const countB = preferenceMap[idB] || 0;
              return countB - countA;
            });
          }

          // Hydrate React state
          setAllMenuItems(serverItems);
          setMenuItems(serverItems);

          if (serverItems.length > 0) {
            const extractedCategories = [
              "All",
              ...new Set(serverItems.map((item) => item.category).filter(Boolean)),
            ];
            setPublicCategories(extractedCategories);
          }
        }
      } catch (error) {
        console.error("PWA reload hydration breakdown:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchScreenRequirements();
  }, [tableId]);

  useEffect(() => {
    if (selectedCategory === "All") {
      setMenuItems(allMenuItems);
    } else {
      // Perform an instant local client filter without hitting the server
      const filtered = allMenuItems.filter((item) => item.category === selectedCategory);
      setMenuItems(filtered);
    }
  }, [selectedCategory, allMenuItems]);

  // --- 5. DYNAMIC PRICE RESOLUTION & TOTAL CALCULATIONS ---
  const { totalItems, totalPrice } = useMemo(() => {
    return menuItems.reduce(
      (acc, item) => {
        const currentId = item._id || item.id;
        const qty = cart[currentId] || 0;

        // RESOLVE TIER PRICE: Select correct schema field dynamically
        const resolvedUnitPrice = currentTier === "doings" ? item.doingsPrice : item.regularPrice;

        return {
          totalItems: acc.totalItems + qty,
          totalPrice: acc.totalPrice + qty * (resolvedUnitPrice || 0),
        };
      },
      { totalItems: 0, totalPrice: 0 },
    );
  }, [cart, menuItems, currentTier]);

  const [request, response, promptAsync] = Google.useAuthRequest({
    // 1. For Expo Go or Web testing
    // webClientId: "607742650924-4qvotvu1q75g3a9dchind088c87pmpco.apps.googleusercontent.com",
    webClientId: "607742650924-2ei9go2bl635sl9gh1pakdj2rqr3s0kn.apps.googleusercontent.com",

    // 2. For your physical iPhone build
    iosClientId: "607742650924-mbcms1rms9i91dj5l9cdp4143lgua83c.apps.googleusercontent.com",

    // 3. For your Android build
    androidClientId: "607742650924-k779l559pl0hjfse5a2kch7cqh5j71jf.apps.googleusercontent.com",

    // redirectUri: Platform.OS === "web" ? "https://app.getmeeza.com" : undefined,
    // redirectUri: Platform.OS === "web" ? "http://localhost:8081/" : undefined,
    redirectUri: AuthSession.makeRedirectUri({
      scheme: "http",
      // host: '127.0.0.1', // Swap from localhost to loopback IP
      host: "localhost", //  Swap from localhost to loopback IP
      port: 8081,
      path: "", // Explicitly forces NO trailing slash
    }),
  });

  useEffect(() => {
    if (response?.type === "success") {
      const { authentication } = response;
      const { accessToken } = authentication;

      executeGoogleOrderProcessingPipeline(accessToken);
    }
  }, [response]);

  // 3. Fallback layout indicators to protect UI during cold starts
  if (isLoading || isAuthLoading) {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator size="large" color={Colours.PRIMARY} />
      </View>
    );
  }
  // Reused brand UI layout fallback fields
  const brandName = brandMeta?.brandName || "The Venue";
  const brandAddress = brandMeta?.brandAddress || "Location Details Not Set";
  const brandImage = brandMeta?.image || "https://placehold.co/150";

  // 2. Component Core Operational State Engines
  //   const [menuItems, setMenuItems] = useState([]); // Database items replace array

  // --- 4. CART QUANTITY MANAGEMENT ENGINE ---
  const handleUpdateQuantity = (itemId, action) => {
    setCart((prevCart) => {
      const currentQty = prevCart[itemId] || 0;
      const nextCart = { ...prevCart };

      if (action === "add") {
        nextCart[itemId] = currentQty + 1;
      } else if (action === "subtract" && currentQty > 0) {
        nextCart[itemId] = currentQty - 1;
        if (nextCart[itemId] === 0) delete nextCart[itemId];
      }
      return nextCart;
    });
  };

  const handleBackNavigation = () => {
    // const isLoggedIn = !!userToken; // Check if user has a token
    const loggedIn = !!sub; // If 'sub' exists, they have a valid access token in memory
    const isWeb = Platform.OS === "web";

    console.log("SUB", sub);

    if (isWeb && !loggedIn) {
      navigation.navigate("getStarted");
    } else if (loggedIn && auth?.isProfileComplete === true) {
      navigation.navigate("main");
    } else {
      // Token exists but profile/order isn't complete yet — main isn't mounted.
      // Fall back to something that's guaranteed to exist in this state.
      navigation.goBack();
    }
  };

  const handlePlaceOrder = () => {
    if (isProcessOrderLoading) return;

    // Structural safety validation
    if (!tableId || Object.keys(cart).length === 0) {
      setErrorMessage("Your cart is empty or the table context is missing.");
      setIsErrorCompVisible(true);
      return;
    }

    // If a pending order already exists, prompt for overwrite confirmation
    if (auth?.hasPendingPrepaidOrder || auth?.pendingOrderDetails?.items?.length > 0) {
      setShowOverwriteModal(true);
    } else {
      // If no existing order, process directly
      confirmAndProcessOrder();
    }
  };

  const confirmAndProcessOrder = async () => {
    setShowOverwriteModal(false);

    try {
      setIsProcessOrderLoading(true);

      // Map items to match order item format
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;

        return {
          menuItemId: cartId,
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
          totalItemPrice: (targetPrice || 0) * cart[cartId],
          menuType: currentTier,
        };
      });

      const paymentAmount = finalOrderItems.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);

      // Construct payload matching pendingOrderDetails schema
      const newPendingOrderDetails = {
        amount: paymentAmount,
        checkoutUrl: "",
        tableAnonymity: Boolean(tableAnonymity),
        reference: "",
        tableId,
        items: finalOrderItems,
      };

      // Send request to update user's pendingOrderDetails in backend
      const response = await axiosPrivate.patch("/overwitePendingOrder/overwitePendingOrder", {
        pendingOrderDetails: newPendingOrderDetails,
      });

      const updatedPendingDetails = response.data?.pendingOrderDetails || newPendingOrderDetails;

      // Overwrite local state
      setAuth((prev) => ({
        ...prev,
        fromChooseSpend: true,
        isProfileComplete: true,
        hasPendingPrepaidOrder: true,
        pendingOrderDetails: updatedPendingDetails,
      }));

      // Reset cart
      setCart({});
      navigation.navigate("payForTable", {
        fromChooseSpend: true,
      });
    } catch (error) {
      console.error("Order save communication error:", error);
      setErrorMessage(error?.response?.data?.message || "Failed to save order. Please try again.");
      setIsErrorCompVisible(true);
    } finally {
      setIsProcessOrderLoading(false);
    }
  };

  async function executeOrderProcessingPipeline() {
    //console.log("1. pipeline entered");
    if (isProcessOrderLoading) return;
    // 1. Structural safety validation
    //console.log("2. past loading guard");
    if (!tableId || Object.keys(cart).length === 0) {
      //console.log("3. BAILED - tableId:", tableId, "cart:", cart);

      setErrorMessage("Your cart is empty or the table context is missing.");
      setIsErrorCompVisible(true);
      return;
    }

    //console.log("4. past cart/table guard - proceeding to request");

    try {
      // 2. Map items perfectly to match the backend embedded sub-document array rules
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;

        return {
          menuItemId: cartId, // Maps to schema menuItemId
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
          totalItemPrice: (targetPrice || 0) * cart[cartId], // Required by your backend ledger hook
          menuType: currentTier, // ENUM: "regular" or "doings"
        };
      });

      // 3. Build order payload tailored for your table batch schema push
      // We send this as a new order batch object ready for an array update
      const newOrderPayload = {
        orderTotalAmount: totalPrice,
        status: "pending", // Schema default fallback setting
        items: finalOrderItems,
        phoneNumber: whatsappNumber,
        tableAnonymity,
      };

      //console.log("Transmitting transactional package to backend endpoint:", newOrderPayload);
      //console.log("Transmitting transmmut:", finalOrderItems);
      setIsProcessOrderLoading(true);
      // 4. Send network request to append the order to the virtual table
      // Assuming your endpoint updates a table, e.g., POST or PATCH to /tables/${tableId}/orders
      //Mostly Phone numbersBased
      const response = await axiosWithCredentials.post(
        `/createTableOrderPublic/createTableOrderPublic/${tableId}`,
        {
          ...newOrderPayload,
        },
      );

      //console.log("this here");

      if (response.status === 200 || response.status === 201) {
        const { accessToken, user, isProfileComplete } = response.data;

        console.log("AccessT", accessToken, "isProfileComp", isProfileComplete);

        setAuth({ accessToken, isProfileComplete });

        // Store profile traits and server configurations if returned in the response
        // if (guestUser) setUserInfo(guestUser);
        // if (activitySettings) setActivitySettings(activitySettings);
        // setTableData(tableData);

        setSuccessMessage(`Order placed in ${currentTier.toUpperCase()} Mode! Processing items.`);
        setIsSuccessCompVisible(true);
        setCart({}); // Flash clean state wipe upon completion
      }
    } catch (error) {
      console.error("Order dispatch communication error:", error);
      setErrorMessage(
        error?.response?.data?.message || "Failed to submit order. Please try again.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsProcessOrderLoading(false);
    }
  }

  async function executeOrderProcessingPrivatePipeline() {
    if (isProcessOrderLoading) return;

    // 1. Structural safety validation
    if (!tableId || Object.keys(cart).length === 0) {
      setErrorMessage("Your cart is empty or the table context is missing.");
      setIsErrorCompVisible(true);
      return;
    }

    try {
      setIsProcessOrderLoading(true);

      // STEP 2: Map items perfectly to match the backend initialization array format
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;

        return {
          menuItemId: cartId,
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
          // Optional tracking sub-properties depending on your server-side map parsing
          totalItemPrice: (targetPrice || 0) * cart[cartId],
          menuType: currentTier,
        };
      });

      const paymentAmount = finalOrderItems.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);

      console.log("Calculated Private Order Total Amount:", paymentAmount);

      // STEP 3: Request the checkout intent payload token link from the backend
      // Utilizing axiosPrivate ensures current access credentials from context pass automatically
      const checkoutSetup = await axiosPrivate.post("/payments2/initialize-checkout", {
        tableId,
        items: finalOrderItems,
        tableAnonymity,
        phoneNumber: whatsappNumber, // Folded in from local configuration input
      });

      if (checkoutSetup.data.status === "success") {
        // STEP 4: Store flags locally to pass state monitoring to PayForTable screen intercepts
        setAuth((prev) => ({
          ...prev,
          isProfileComplete: true,
          hasPendingPrepaidOrder: checkoutSetup.data?.hasPendingPrepaidOrder,
          pendingOrderDetails: checkoutSetup.data?.pendingOrderDetails,
          reference: checkoutSetup.data?.data?.reference,
        }));

        console.log("Private checkout sequence initialized successfully.");

        // Clean local workspace state
        setCart({});

        // If you use an explicit modal/component wrapper configuration layer, hide it here:
        // setIsAuthModalVisible(false);
      } else {
        setErrorMessage("Gateway initialization rejection.");
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      console.error("Order dispatch communication error:", error);
      setErrorMessage(
        error?.response?.data?.message || "Failed to submit order. Please try again.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsProcessOrderLoading(false);
    }
  }

  async function executeOrderProcessingPrivatePipelineTopUp() {
    if (isProcessOrderLoading) return;

    // 1. Structural safety validation
    if (!tableId || Object.keys(cart).length === 0) {
      setErrorMessage("Your cart is empty or the table context is missing.");
      setIsErrorCompVisible(true);
      return;
    }

    try {
      setIsProcessOrderLoading(true);

      // STEP 2: Map items perfectly to match the backend initialization array format
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;

        return {
          menuItemId: cartId,
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
          // Optional tracking sub-properties depending on your server-side map parsing
          totalItemPrice: (targetPrice || 0) * cart[cartId],
          menuType: currentTier,
        };
      });

      const paymentAmount = finalOrderItems.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);

      console.log("Calculated Private Order Total Amount:", paymentAmount);

      // STEP 3: Request the checkout intent payload token link from the backend
      // Utilizing axiosPrivate ensures current access credentials from context pass automatically
      const checkoutSetup = await axiosPrivate.post("/payments2/initialize-checkout-topUp", {
        tableId,
        items: finalOrderItems,
        tableAnonymity,
        phoneNumber: whatsappNumber, // Folded in from local configuration input
      });

      if (checkoutSetup.data.status === "success") {
        // STEP 4: Store flags locally to pass state monitoring to PayForTable screen intercepts
        console.log("Teating hasPendingOrder", checkoutSetup.data?.hasPendingPrepaidOrder);
        sessionStorage.removeItem("is_topup_flow");
        setAuth((prev) => ({
          ...prev,
          isProfileComplete: true,
          hasPendingPrepaidOrder: checkoutSetup.data?.hasPendingPrepaidOrder,
          pendingOrderDetails: checkoutSetup.data?.pendingOrderDetails,
        }));

        console.log("Private checkout sequence initialized successfully.");

        // Clean local workspace state
        setCart({});

        // If you use an explicit modal/component wrapper configuration layer, hide it here:
        // setIsAuthModalVisible(false);
      } else {
        setErrorMessage("Gateway initialization rejection.");
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      console.error("Order dispatch communication error:", error);
      setErrorMessage(
        error?.response?.data?.message || "Failed to submit order. Please try again.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsProcessOrderLoading(false);
    }
  }

  const allHaveImages =
    menuItems.length > 0 && menuItems.every((item) => item.image && item.image.trim() !== "");

  if (isProcessOrderLoading) {
    return (
      <View
        style={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "#fff" }}
      >
        <ActivityIndicator size="large" color={Colours.PRIMARY} />
        <Text style={{ marginTop: dynamicSpacing(15), fontFamily: "Sen-Bold", color: "#1A1A1A" }}>
          {/* Sending order to kitchen... */}
          Proceeding to Meeza Checkout...
        </Text>
      </View>
    );
  }

  return (
    <SafeAreaView style={styles.safeArea}>
      {isLoading ? (
        <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
          <ActivityIndicator size="large" color={Colours.PRIMARY} />
        </View>
      ) : (
        // 🌟 WRAPPER VIEW: Ensures children flex and stack correctly
        <View style={styles.screenWrapper}>
          {/* 📌 FIXED TOP HEADER: Completely isolated from the scrolling list ecosystem */}
          <View style={styles.fixedHeader}>
            <TopHeaderComponent
              headerText={"Explore Menu"}
              hideScreen={() => {
                if (navigation.canGoBack()) {
                  navigation.goBack();
                } else {
                  navigation.navigate("chooseFlex", { tableId });
                }
              }}
            />
          </View>

          {/* DYNAMIC SCROLLER */}
          <View style={styles.scrollArea}>
            <FlatList
              data={menuItems}
              keyExtractor={(item) => item._id || item.id}
              showsVerticalScrollIndicator={false}
              // ❌ Removed stickyHeaderIndices={[0]} since the header is now truly fixed above the list
              contentContainerStyle={{
                paddingBottom: totalItems > 0 ? dynamicSpacing(140) : dynamicSpacing(40),
              }}
              // 🌟 CLEAN SCROLLABLE HEADER ELEMENTS
              ListHeaderComponent={
                <View
                  style={{ paddingHorizontal: dynamicSpacing(20), paddingTop: dynamicSpacing(10) }}
                >
                  {/* BRAND HERO CARD - Modern Dual/Single State */}
                  {isOngoingShow ? (
                    <View style={styles.brandHeroCard}>
                      {/* BADGE OVERLAY */}
                      <View style={styles.liveBadge}>
                        <View style={styles.liveDot} />
                        <Text style={styles.liveBadgeText}>ONGOING SHOW</Text>
                      </View>

                      {/* BRAND COMPARISON ROW */}
                      <View style={styles.collabRow}>
                        {/* PROMOTER BRAND */}
                        <View style={styles.brandCol}>
                          <Image
                            source={{
                              uri: activeShowData?.promoter?.image || "https://placehold.co/150",
                            }}
                            style={styles.collabImage}
                            contentFit="cover"
                            cachePolicy="disk"
                          />
                          <Text style={styles.collabNameTxt} numberOfLines={1}>
                            {activeShowData?.promoter?.brandName || "Promoter"}
                          </Text>
                        </View>

                        {/* MATCHUP DIVIDER */}
                        <View style={styles.dividerBadge}>
                          <Text style={styles.dividerTxt}>✕</Text>
                        </View>

                        {/* VENUE BRAND */}
                        <View style={styles.brandCol}>
                          <Image
                            source={{ uri: brandImage || "https://placehold.co/150" }}
                            style={styles.collabImage}
                            contentFit="cover"
                            cachePolicy="disk"
                          />
                          <Text style={styles.collabNameTxt} numberOfLines={1}>
                            {brandName || "Venue"}
                          </Text>
                        </View>
                      </View>

                      {/* SHOW CAPTION */}
                      <View style={styles.showCaptionContainer}>
                        <Text style={styles.showCaptionTxt} numberOfLines={2}>
                          {activeShowData?.caption || "Live Event Information"}
                        </Text>
                        {brandAddress && (
                          <View style={styles.addressRow}>
                            <Ionicons
                              name="location-sharp"
                              size={dynamicSize(14)}
                              color={Colours.PRIMARY || "#FF3B30"}
                              style={{ marginRight: dynamicSpacing(4) }}
                            />
                            <Text style={styles.addressTxt} numberOfLines={1}>
                              {brandAddress}
                            </Text>
                          </View>
                        )}
                      </View>
                    </View>
                  ) : (
                    /* STANDARD BRAND CARD */
                    <View style={styles.brandHeroCard}>
                      <View style={styles.standardHeroRow}>
                        <Image
                          source={{ uri: brandImage || "https://placehold.co/150" }}
                          style={styles.brandImage}
                          contentFit="cover"
                          cachePolicy="disk"
                        />
                        <View style={styles.brandMetaInfo}>
                          <Text style={styles.nameTxt} numberOfLines={1}>
                            {brandName || "Company Title"}
                          </Text>
                          <Text style={styles.emailTxt} numberOfLines={2}>
                            {brandAddress || "Location Details Not Set"}
                          </Text>
                        </View>
                      </View>
                    </View>
                  )}

                  {/* CATEGORY TABS - Will scroll away naturally */}
                  <View style={{ marginBottom: dynamicSpacing(15) }}>
                    <FlatList
                      data={publicCategories}
                      horizontal
                      showsHorizontalScrollIndicator={false}
                      keyExtractor={(item) => item}
                      renderItem={({ item }) => {
                        const isActive = selectedCategory === item;
                        return (
                          <TouchableOpacity
                            onPress={() => setSelectedCategory(item)}
                            style={[styles.categoryTab, isActive && styles.activeCategoryTab]}
                          >
                            <Text
                              style={[
                                styles.categoryTabText,
                                isActive && styles.activeCategoryTabText,
                              ]}
                            >
                              {item}
                            </Text>
                          </TouchableOpacity>
                        );
                      }}
                    />
                  </View>
                </View>
              }
              ListEmptyComponent={() => (
                <View style={{ alignItems: "center", marginTop: 40 }}>
                  <Text style={{ color: "#8E8E93" }}>
                    No available items found in this section.
                  </Text>
                </View>
              )}
              renderItem={({ item }) => {
                const currentId = item._id || item.id;
                const quantity = cart[currentId] || 0;
                const activePriceDisplay =
                  currentTier === "doings" ? item.doingsPrice : item.regularPrice;

                // 1. TEXT-ONLY COMPACT LAYOUT (If missing images)
                if (!allHaveImages) {
                  return (
                    <View style={[styles.menuItemCard, { marginHorizontal: dynamicSpacing(20) }]}>
                      <View style={styles.menuItemDetails}>
                        <Text style={styles.menuItemName} numberOfLines={2}>
                          {item.name}
                        </Text>
                        {item.description && (
                          <Text
                            style={{
                              fontSize: dynamicFontSize(12),
                              color: "#666666",
                              marginTop: dynamicSpacing(2),
                            }}
                            numberOfLines={2}
                          >
                            {item.description}
                          </Text>
                        )}
                        <Text style={styles.menuItemPrice}>
                          ₦{activePriceDisplay ? activePriceDisplay.toLocaleString() : "0"}
                        </Text>
                      </View>

                      {/* COUNTER CONTROLS */}
                      <View style={styles.counterContainer}>
                        {quantity > 0 && (
                          <>
                            <TouchableOpacity
                              onPress={() => handleUpdateQuantity(currentId, "subtract")}
                              style={styles.counterBtn}
                            >
                              <Ionicons
                                name="remove"
                                size={dynamicSize(16)}
                                color={Colours.PRIMARY}
                              />
                            </TouchableOpacity>
                            <Text style={styles.counterText}>{quantity}</Text>
                          </>
                        )}
                        <TouchableOpacity
                          onPress={() => handleUpdateQuantity(currentId, "add")}
                          style={[styles.counterBtn, { backgroundColor: Colours.PRIMARY }]}
                        >
                          <Ionicons name="add" size={dynamicSize(16)} color="white" />
                        </TouchableOpacity>
                      </View>
                    </View>
                  );
                }

                return (
                  <View style={[styles.menuItemCard, { marginHorizontal: dynamicSpacing(20) }]}>
                    <Image
                      source={{ uri: item.image || brandImage }}
                      style={styles.menuItemImage}
                      contentFit="cover"
                    />
                    <View style={styles.menuItemDetails}>
                      <Text style={styles.menuItemName} numberOfLines={2}>
                        {item.name}
                      </Text>
                      <Text style={styles.menuItemPrice}>
                        ₦{activePriceDisplay ? activePriceDisplay.toLocaleString() : "0"}
                      </Text>
                    </View>
                    <View style={styles.counterContainer}>
                      {quantity > 0 && (
                        <>
                          <TouchableOpacity
                            onPress={() => handleUpdateQuantity(currentId, "subtract")}
                            style={styles.counterBtn}
                          >
                            <Ionicons
                              name="remove"
                              size={dynamicSize(16)}
                              color={Colours.PRIMARY}
                            />
                          </TouchableOpacity>
                          <Text style={styles.counterText}>{quantity}</Text>
                        </>
                      )}
                      <TouchableOpacity
                        onPress={() => handleUpdateQuantity(currentId, "add")}
                        style={[styles.counterBtn, { backgroundColor: Colours.PRIMARY }]}
                      >
                        <Ionicons name="add" size={dynamicSize(16)} color="white" />
                      </TouchableOpacity>
                    </View>
                  </View>
                );
              }}
            />
          </View>

          {/* 📌 FIXED CHECKOUT DRAWER: Placed completely outside the FlatList layout tree */}
          {totalItems > 0 && (
            <View
              style={[
                styles.checkoutStickyContainer,
                {
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  backgroundColor: "#ffffff",
                  borderTopWidth: 1,
                  borderTopColor: "#EAEAEA",
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: -3 },
                  shadowOpacity: 0.1,
                  shadowRadius: 5,
                  elevation: 10,
                },
              ]}
            >
              {/* 🌟 EXPANDABLE BASKET DETAILS CONTAINER */}
              {isCartExpanded && (
                <View
                  style={{
                    padding: dynamicSpacing(20),
                    borderBottomWidth: 1,
                    borderBottomColor: "#F5F5F7",
                    maxHeight: dynamicSize(250),
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginBottom: dynamicSpacing(10),
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "Sen-Bold",
                        fontSize: dynamicFontSize(16),
                        color: "#1A1A1A",
                      }}
                    >
                      Review Selected Items
                    </Text>
                    <TouchableOpacity onPress={() => setIsCartExpanded(false)}>
                      <Ionicons name="chevron-down" size={dynamicSize(20)} color="#8E8E93" />
                    </TouchableOpacity>
                  </View>

                  <ScrollView showsVerticalScrollIndicator={true} nestedScrollEnabled={true}>
                    {Object.keys(cart).map((cartId) => {
                      const itemMatch = menuItems.find((m) => (m._id || m.id) === cartId);
                      const itemQty = cart[cartId];
                      if (itemQty <= 0 || !itemMatch) return null;

                      const itemPrice =
                        currentTier === "doings" ? itemMatch.doingsPrice : itemMatch.regularPrice;

                      return (
                        <View
                          key={cartId}
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            paddingVertical: dynamicSpacing(8),
                          }}
                        >
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: dynamicSpacing(8),
                              flex: 1,
                              paddingRight: dynamicSpacing(10),
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "Sen-Bold",
                                color: Colours.PRIMARY,
                                fontSize: dynamicFontSize(14),
                              }}
                            >
                              {itemQty}x
                            </Text>
                            <Text
                              style={{ color: "#333", fontSize: dynamicFontSize(14) }}
                              numberOfLines={1}
                            >
                              {itemMatch.name}
                            </Text>
                          </View>
                          <Text
                            style={{
                              fontFamily: "Sen-Bold",
                              color: "#1A1A1A",
                              fontSize: dynamicFontSize(14),
                            }}
                          >
                            ₦{((itemPrice || 0) * itemQty).toLocaleString()}
                          </Text>
                        </View>
                      );
                    })}
                  </ScrollView>
                </View>
              )}

              {/* CORE ACTION SUB-BAR */}
              <View style={styles.priceRowContainer}>
                {/* Clicking this side toggles the itemized scroll overlay drawer */}
                <TouchableOpacity
                  activeOpacity={0.7}
                  onPress={() => setIsCartExpanded(!isCartExpanded)}
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: dynamicSpacing(6),
                  }}
                >
                  <View>
                    <Text style={styles.basketCountText}>
                      {totalItems} {totalItems === 1 ? "item" : "items"} selected
                    </Text>
                    <Text style={styles.basketTotalValue}>₦{totalPrice.toLocaleString()}</Text>
                  </View>
                  <Ionicons
                    name={isCartExpanded ? "chevron-down" : "chevron-up"}
                    size={dynamicSize(16)}
                    color={Colours.PRIMARY}
                    style={{ marginTop: dynamicSpacing(12) }}
                  />
                </TouchableOpacity>

                <TouchableOpacity style={styles.proceedBtn} onPress={handlePlaceOrder}>
                  {isProcessOrderLoading ? (
                    <ActivityIndicator size="large" color="white" />
                  ) : (
                    <Text style={styles.proceedBtnText}>Place Order</Text>
                  )}
                  <MaterialCommunityIcons
                    name="silverware-fork-knife"
                    size={dynamicSize(18)}
                    color="white"
                  />
                </TouchableOpacity>
              </View>
            </View>
          )}
        </View>
      )}

      {/* ── OVERWRITE PENDING ORDER NOTICE ALERT OVERLAY ── */}
      <Modal visible={showOverwriteModal} transparent={true} animationType="fade">
        <View style={styles.alertModalCenteredBackdrop}>
          <View style={styles.alertModalContainerBox}>
            {/* Warning/Alert Icon Header */}
            <View style={styles.alertIconHeaderContainer}>
              <MaterialCommunityIcons
                name="alert-circle-outline"
                size={32}
                color={Colours.PRIMARY}
              />
            </View>

            <Text style={styles.alertModalHeading}>Update Existing Order?</Text>

            <Text style={styles.alertModalMessage}>
              Your previous order will be updated and replaced with this current order.
            </Text>

            <View style={styles.alertModalButtonWrapper}>
              {/* Cancel Action */}
              <TouchableOpacity
                style={styles.alertModalCancelButton}
                onPress={() => setShowOverwriteModal(false)}
              >
                <Text style={styles.alertModalCancelText}>Cancel</Text>
              </TouchableOpacity>

              {/* Confirm Overwrite & Process Action */}
              <TouchableOpacity style={styles.alertModalOkButton} onPress={confirmAndProcessOrder}>
                <Text style={styles.alertModalOkText}>Replace Order</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* MODAL OVERLAY PORTAL */}
      <Modal visible={isErrorCompVisible} transparent animationType="fade">
        <ErrorAlertComp
          message={errorMessage}
          onClose={() => {
            setCart({});
            setIsErrorCompVisible(false);
          }}
        />
      </Modal>
      <Modal visible={isSuccessCompVisible} transparent animationType="fade">
        <SuccessAlertComp
          message={successMessage}
          onClose={() => {
            setCart({});
            setIsSuccessCompVisible(false);
            handleBackNavigation();
          }}
        />
      </Modal>
    </SafeAreaView>
  );
};

export default RevisitMenu;

// --- STYLING PATTERNS ARCHITECTURE ---
const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: "#F9F9FA",
    // On web, SafeAreaView doesn't constrain height by default
    ...(Platform.OS === "web" && {
      height: "100vh",
      overflow: "hidden",
    }),
  },
  scrollArea: {
    flex: 1,
    overflow: "hidden",
  },

  // Re-used identical structural brand card configurations
  brandHeroCard: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "white",
    padding: dynamicSpacing(16),
    borderRadius: dynamicSize(16),
    marginBottom: dynamicSpacing(20),
    elevation: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
  },

  brandHeroCard: {
    backgroundColor: "#FFFFFF",
    padding: dynamicSpacing(16),
    borderRadius: dynamicSize(20),
    marginBottom: dynamicSpacing(20),
    elevation: 3,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 12,
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.03)",
    position: "relative",
    overflow: "hidden",
  },
  brandImage: {
    width: dynamicSize(64),
    height: dynamicSize(64),
    borderRadius: dynamicSize(12),
    backgroundColor: "#F5F5F7",
  },
  brandMetaInfo: {
    flex: 1,
    marginLeft: dynamicSpacing(15),
    justifyContent: "center",
  },
  nameTxt: {
    color: Colours.DARKGRAY || "#1A1A1A",
    fontSize: dynamicFontSize(18),
    fontFamily: "Sen-Bold",
    marginBottom: dynamicSpacing(2),
  },
  emailTxt: {
    color: "#666",
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
    lineHeight: dynamicFontSize(16),
  },
  screenWrapper: {
    flex: 1,
    overflow: "hidden",
  },
  fixedHeader: {
    backgroundColor: "#fff",
    zIndex: 1000,
  },
  googleIcon: {
    width: dynamicSize(20),
    height: dynamicSize(20),
    marginRight: dynamicSpacing(12),
  },
  // Menu Category items
  categoryTab: {
    paddingHorizontal: dynamicSpacing(16),
    paddingVertical: dynamicSpacing(8),
    borderRadius: dynamicSize(20),
    backgroundColor: "#EBEBEF",
    marginRight: dynamicSpacing(10),
  },
  activeCategoryTab: {
    backgroundColor: Colours.PRIMARY,
  },
  categoryTabText: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(13),
    color: "#555",
  },
  activeCategoryTabText: {
    color: "white",
  },

  // Menu List cards
  menuItemCard: {
    flexDirection: "row",
    backgroundColor: "white",
    padding: dynamicSpacing(12),
    borderRadius: dynamicSize(14),
    alignItems: "center",
    marginBottom: dynamicSpacing(12),
    borderWidth: 1,
    borderColor: "#F0F0F2",
  },
  menuItemImage: {
    width: dynamicSize(65),
    height: dynamicSize(65),
    borderRadius: dynamicSize(10),
    backgroundColor: "#F5F5F7",
  },
  menuItemDetails: {
    flex: 1,
    marginLeft: dynamicSpacing(12),
    paddingRight: dynamicSpacing(8),
  },
  menuItemName: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(14),
    color: "#222",
    marginBottom: dynamicSpacing(4),
  },
  menuItemPrice: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(15),
    color: Colours.PRIMARY,
  },

  // Counter Elements
  counterContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F5F5F7",
    borderRadius: dynamicSize(20),
    padding: dynamicSpacing(4),
    gap: dynamicSpacing(8),
  },
  counterBtn: {
    width: dynamicSize(28),
    height: dynamicSize(28),
    borderRadius: dynamicSize(14),
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
    elevation: 1,
  },
  counterText: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(14),
    color: "#222",
    minWidth: dynamicSpacing(16),
    textAlign: "center",
  },

  // Footer Placement Panel
  checkoutStickyContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "white",
    paddingHorizontal: dynamicSpacing(20),
    paddingTop: dynamicSpacing(15),
    paddingBottom: Platform.OS === "ios" ? dynamicSpacing(35) : dynamicSpacing(20),
    borderTopLeftRadius: dynamicSize(20),
    borderTopRightRadius: dynamicSize(20),
    elevation: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    zIndex: 1000,
  },
  priceRowContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  basketCountText: {
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(12),
    color: "gray",
  },
  basketTotalValue: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(22),
    color: "#222",
  },
  proceedBtn: {
    backgroundColor: Colours.PRIMARY,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: dynamicSpacing(24),
    height: dynamicSize(50),
    borderRadius: dynamicSize(14),
    gap: dynamicSpacing(8),
  },
  proceedBtnText: {
    color: "white",
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(15),
  },

  /* ── CUSTOM PAYSTACK NOTICE POPUP STYLES ── */
  alertModalCenteredBackdrop: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },
  alertModalContainerBox: {
    width: "100%",
    maxWidth: 320,
    backgroundColor: "white",
    borderRadius: 20,
    padding: 24,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 8,
  },
  alertIconHeaderContainer: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: "#FFF4F2",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 16,
  },
  alertModalHeading: {
    fontFamily: "Sen-Bold",
    fontSize: 18,
    color: "#1A1A1A",
    marginBottom: 8,
    textAlign: "center",
  },
  alertModalMessage: {
    fontFamily: "Sen-Regular",
    fontSize: 14,
    color: "#555",
    textAlign: "center",
    lineHeight: 22,
    marginBottom: 24,
  },
  alertModalAmountHighlight: {
    fontFamily: "Sen-Bold",
    fontSize: 20,
    color: Colours.PRIMARY,
  },
  alertModalButtonWrapper: {
    flexDirection: "row",
    width: "100%",
    gap: 12,
  },
  alertModalCancelButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 10,
    backgroundColor: "#F5F5F5",
    alignItems: "center",
    justifyContent: "center",
  },
  alertModalCancelText: {
    fontFamily: "Sen-Bold",
    fontSize: 14,
    color: "#666",
  },
  alertModalOkButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 10,
    backgroundColor: Colours.PRIMARY,
    alignItems: "center",
    justifyContent: "center",
  },
  alertModalOkText: {
    fontFamily: "Sen-Bold",
    fontSize: 14,
    color: "white",
  },

  // Live Show Layout
  liveBadge: {
    position: "absolute",
    top: dynamicSpacing(12),
    right: dynamicSpacing(14),
    backgroundColor: "#FFF0F0",
    paddingHorizontal: dynamicSpacing(10),
    paddingVertical: dynamicSpacing(4),
    borderRadius: dynamicSize(20),
    flexDirection: "row",
    alignItems: "center",
  },
  liveDot: {
    width: dynamicSize(6),
    height: dynamicSize(6),
    borderRadius: dynamicSize(3),
    backgroundColor: "#FF3B30",
    marginRight: dynamicSpacing(6),
  },
  liveBadgeText: {
    color: "#FF3B30",
    fontSize: dynamicFontSize(10),
    fontFamily: "Sen-Bold",
    letterSpacing: 0.5,
  },
  collabRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: dynamicSpacing(12),
    paddingHorizontal: dynamicSpacing(10),
  },
  brandCol: {
    alignItems: "center",
    flex: 1,
  },
  collabImage: {
    width: dynamicSize(54),
    height: dynamicSize(54),
    borderRadius: dynamicSize(27),
    backgroundColor: "#F5F5F7",
    borderWidth: 1,
    borderColor: "#EFEFEF",
  },
  collabNameTxt: {
    color: Colours.DARKGRAY || "#1A1A1A",
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Bold",
    marginTop: dynamicSpacing(6),
    textAlign: "center",
  },
  dividerBadge: {
    width: dynamicSize(28),
    height: dynamicSize(28),
    borderRadius: dynamicSize(14),
    backgroundColor: "#F4F4F6",
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: dynamicSpacing(8),
  },
  dividerTxt: {
    fontSize: dynamicFontSize(11),
    fontFamily: "Sen-Bold",
    color: "#8E8E93",
  },
  showCaptionContainer: {
    marginTop: dynamicSpacing(14),
    paddingTop: dynamicSpacing(12),
    borderTopWidth: 1,
    borderTopColor: "#F2F2F7",
    alignItems: "center",
  },
  showCaptionTxt: {
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
    color: Colours.DARKGRAY || "#111111",
    textAlign: "center",
    lineHeight: dynamicFontSize(20),
  },
  // Standard Card Layout
  standardHeroRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  screenWrapper: {
    flex: 1,
    overflow: "hidden",
  },
  fixedHeader: {
    backgroundColor: "#fff",
    zIndex: 1000,
  },

  addressRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: dynamicSpacing(6),
  },
  addressTxt: {
    color: "#666666",
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
    flexShrink: 1, // Prevents text from overflowing container bounds
  },
});
